import firebase from 'firebase/app';
import 'firebase/auth';
import firebaseui from 'firebaseui';

const checkInterval = 50;
const maxCheckAttempts = 300;
let checkAttempts = 0;

const init = function(resolve, reject) {
  const checking = window.setInterval(() => {
    checkAttempts += 1;

    if (checkAttempts > maxCheckAttempts) {
      window.clearInterval(checking);
      reject('Google api did not load in enough time');
      return;
    }

    // Continuously check whether the google api is loaded because if it's still in progress,
    // calling new AuthUI will throw a TypeError
    if (window.gapi && window.gapi.loaded_0) {
      return;
    }

    window.clearInterval(checking);

    resolve(new firebaseui.auth.AuthUI(firebase.auth()));
  }, checkInterval);
};

const AuthUI = function() { };

AuthUI.prototype.getUI = function() {
  return this.uiPromise || (this.uiPromise = new Promise(init));
};

const authUI = new AuthUI();

export default authUI;



// WEBPACK FOOTER //
// ./src/services/authUIService.js